import { getDocs, collection, DocumentReference } from "firebase/firestore"

/**
 * Fetch all docs in the subcollection
 * @param {DocumentReference} mainDocRef
 * @param {string} subcollectionName
 * @return {Promise<Array>}
 */
export async function getSubcollectionDocs<TDoc extends { id: string | number }>(
  mainDocRef: DocumentReference,
  subcollectionName: string,
): Promise<TDoc[]> {
  const subcollectionRef = collection(mainDocRef, subcollectionName)

  const docsSnapshot = await getDocs(subcollectionRef)

  const docs: TDoc[] = []

  docsSnapshot.forEach((docSnapshot) => {
    const doc = {
      id: docSnapshot.id,
      ...docSnapshot.data(),
    } as TDoc

    docs.push(doc)
  })

  return docs
}
